/* PZR-MC-A02 — production-safe Bestseller interaction only. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const decoratePrices = (root = document) => {
    root.querySelectorAll('.pzr-best-card__line > span:first-child').forEach((price) => {
      if (price.dataset.pzrPriceReady === 'true') return;

      const raw = price.textContent.trim();
      if (!raw) return;

      price.dataset.pzrPriceReady = 'true';
      price.classList.add('pzr-best-card__price');
      price.textContent = '';

      const fromMatch = raw.match(/^FROM\s+(.+)$/i);
      if (fromMatch) {
        const prefix = document.createElement('span');
        prefix.className = 'pzr-best-card__price-prefix';
        prefix.textContent = 'FROM';
        price.append(prefix);

        const value = document.createElement('span');
        value.className = 'pzr-best-card__price-value';
        value.textContent = fromMatch[1];
        price.append(value);
        return;
      }

      const value = document.createElement('span');
      value.className = 'pzr-best-card__price-value';
      value.textContent = raw;
      price.append(value);
    });
  };

  const initializeSection = (section) => {
    decoratePrices(section);

    const viewport = section.querySelector('[data-pzr-best-viewport]');
    const primary = section.querySelector('[data-pzr-best-primary]');
    if (!viewport || !primary || viewport.dataset.pzrBestReady === 'true') return;
    viewport.dataset.pzrBestReady = 'true';

    let raf = 0;
    let last = 0;
    let resumeAt = 0;
    let dragging = false;
    let dragMoved = false;
    let suppressClick = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let autoPosition = viewport.scrollLeft;
    let hovered = false;
    let focusWithin = false;
    let touchActive = false;
    const speed = 18;
    const gap = 20;

    const pauseFor = (delay = 700) => {
      resumeAt = Math.max(resumeAt, performance.now() + delay);
    };

    const normalizeLoop = () => {
      const resetAt = primary.scrollWidth + gap;
      if (resetAt <= 0) return;
      let next = viewport.scrollLeft;
      while (next >= resetAt) next -= resetAt;
      viewport.scrollLeft = next;
      autoPosition = next;
    };

    const motionPaused = (time) => (
      reduceMotion.matches || hovered || focusWithin || touchActive || dragging || time < resumeAt
    );

    const tick = (time) => {
      if (!last) last = time;
      const dt = Math.min(40, time - last);
      last = time;
      if (!motionPaused(time)) {
        const resetAt = primary.scrollWidth + gap;
        autoPosition += speed * (dt / 1000);
        if (resetAt > 0) while (autoPosition >= resetAt) autoPosition -= resetAt;
        viewport.scrollLeft = autoPosition;
      } else {
        autoPosition = viewport.scrollLeft;
      }
      raf = requestAnimationFrame(tick);
    };

    viewport.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') hovered = true;
    });
    viewport.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') {
        hovered = false;
        pauseFor(180);
      }
    });
    viewport.addEventListener('focusin', () => { focusWithin = true; });
    viewport.addEventListener('focusout', () => {
      window.setTimeout(() => {
        focusWithin = viewport.contains(document.activeElement);
        if (!focusWithin) pauseFor(250);
      }, 0);
    });
    viewport.addEventListener('touchstart', () => { touchActive = true; }, { passive: true });
    viewport.addEventListener('touchend', () => { touchActive = false; pauseFor(); }, { passive: true });
    viewport.addEventListener('touchcancel', () => { touchActive = false; pauseFor(); }, { passive: true });
    viewport.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) > 0.5) pauseFor();
    }, { passive: true });
    viewport.addEventListener('dragstart', (event) => event.preventDefault());

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      dragging = true;
      dragMoved = false;
      suppressClick = false;
      dragStartX = event.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - dragStartX;
      if (!dragMoved && Math.abs(delta) > 5) {
        dragMoved = true;
        viewport.setPointerCapture?.(event.pointerId);
      }
      if (!dragMoved) return;
      viewport.scrollLeft = dragStartScroll - delta;
      event.preventDefault();
    });

    const endDrag = (event) => {
      if (!dragging) return;
      suppressClick = dragMoved;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture?.(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      normalizeLoop();
      pauseFor(800);
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    raf = requestAnimationFrame(tick);
    reduceMotion.addEventListener?.('change', () => {
      last = 0;
      if (reduceMotion.matches) pauseFor(0);
    });
    window.addEventListener('pagehide', () => cancelAnimationFrame(raf), { once: true });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-pzr-best]').forEach(initializeSection);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
